<template>
  <div
    v-if="impersonation"
    class="impersonation-banner"
    dir="rtl"
  >
    <span>
      شما با حساب ادمین وارد حساب «{{ customerName }}» شده‌اید؛ همهٔ کارها در لاگ ثبت می‌شود.
    </span>
    <button
      type="button"
      :disabled="busy"
      @click="back"
    >
      بازگشت به حساب ادمین
    </button>
  </div>
</template>

<script>
import customerService from '@/services/customer.service'

const BANNER_HEIGHT = '40px'

export default {
  data() {
    const user = JSON.parse(localStorage.getItem('user'))
    return {
      user,
      busy: false,
    }
  },
  computed: {
    impersonation() {
      return this.user && this.user.impersonation ? this.user.impersonation : null
    },
    customerName() {
      return this.user ? `${this.user.name || ''} ${this.user.family || ''}`.trim() || this.user.mobile : ''
    },
  },
  mounted() {
    if (this.impersonation) document.body.style.paddingTop = BANNER_HEIGHT
  },
  methods: {
    async back() {
      this.busy = true
      const { admin, adminKey } = this.impersonation
      try {
        await customerService.endImpersonation()
      } catch (error) {
        // حتی اگر پایان جلسه ثبت نشد (مثلاً توکن منقضی شده)، ادمین باید برگردد
      }
      localStorage.removeItem('user')
      localStorage.removeItem('user_first')
      if (admin) localStorage.setItem(adminKey || 'user', JSON.stringify(admin))
      document.body.style.paddingTop = ''
      window.location.href = '/admin/customer/list'
    },
  },
}
</script>

<style scoped>
.impersonation-banner {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 40px;
  z-index: 99999;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  background: #ea5455;
  color: #fff;
  font-size: 13px;
}
.impersonation-banner button {
  background: #fff;
  color: #ea5455;
  border: 0;
  border-radius: 4px;
  padding: 2px 10px;
  cursor: pointer;
}
</style>
